<template>
  <div v-if="currentUser" class="reports-admin">
    <div class="page-header">
      <h1>Zgłoszenia</h1>
      <button class="btn-outline" @click="getReports">Odśwież</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Lista zgłoszeń</h2>
      </div>

      <div class="toolbar-row">
        <div class="results-chip">Wyniki: <b>{{ count || 0 }}</b></div>
        <div class="pagination">
          <button class="btn-outline" @click="prevPage" :disabled="page <= 1">
            &#8592; Poprzednia
          </button>
          <span class="page-info">Strona {{ page }}/{{ totalPages }}</span>
          <button class="btn-outline" @click="nextPage" :disabled="page >= totalPages">
            Następna &#8594;
          </button>
        </div>
      </div>
    </div>

    <div class="section-card list-card">
      <div class="reports-grid" v-if="reports && reports.length > 0">
        <ReportCard
            v-for="report in reports"
            :key="report.id"
            :id="report.id"
            :type="report.announcement_id ? 'ogłoszenie' : 'usługa'"
            :comment="report.comment"
            :date="report.created_at"
            @deleteReport="(id) => deleteReport(id)"
        />
      </div>

      <div v-else class="empty-state">
        <p>Brak zgłoszeń do wyświetlenia.</p>
      </div>
    </div>
  </div>
</template>

<script>
import ReportCard from '@/components/SpecialComponents/ReportCard.vue';
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'AdminReports',
  components: { ReportCard },
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      page: 1,
      reports: null,
      searchInput: '',
      count: 0,
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
    totalPages() {
      const pages = Math.ceil((this.count || 0) / 50);
      return pages > 0 ? pages : 1;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getReports();
  },
  methods: {
    getReports() {
      axios.post('/ReportSearch', {
        page: this.page,
        limit: 50,
      }, authHeader()).then(res => {
        this.reports = res.data.items || [];
        this.count = res.data.count || 0;
      });
    },
    prevPage() {
      if (this.page > 1) {
        this.page -= 1;
        this.getReports();
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.getReports();
      }
    },
    deleteReport(id) {
      axios.delete(`/Report/${id}`, authHeader()).then(() => {
        this.appStore.setIsSuccess('Pomyślnie usunięto zgłoszenie');
        this.getReports();
      }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.reports-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
}

.results-chip {
  font-size: 1.4rem;
  color: #374151;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 6px 12px;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.page-info {
  font-size: 1.5rem;
  color: #6b7280;
  font-weight: 500;
  min-width: 130px;
  text-align: center;
}

.list-card {
  margin-bottom: 0;
}

.reports-grid {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
}

.empty-state {
  text-align: center;
  padding: 28px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.35rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .toolbar-row {
    flex-direction: column;
    align-items: stretch;
  }

  .pagination {
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .reports-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>